import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  // On phones the trail collapses to a single back link — the nearest linkable
  // ancestor. Desktop keeps the full trail.
  const parent = [...items].reverse().find((item) => item.to);

  return (
    <nav aria-label="Breadcrumb" className="text-xs text-ink-faint">
      {parent?.to && (
        <Link
          to={parent.to}
          className="-ml-1 inline-flex min-h-[2rem] items-center gap-0.5 pr-2 text-ink-muted hover:text-ink sm:hidden"
        >
          <ChevronLeft className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="max-w-[16rem] truncate">{parent.label}</span>
        </Link>
      )}
      <ol className={`min-w-0 items-center gap-1.5 ${parent?.to ? 'hidden sm:flex' : 'flex'}`}>
        {items.map((item, i) => (
          <Fragment key={`${item.label}-${i}`}>
            {i > 0 && (
              <li aria-hidden="true" className="text-ink-faint">
                /
              </li>
            )}
            <li className="flex min-w-0 items-center">
              {item.to ? (
                <Link to={item.to} className="max-w-[14rem] truncate hover:text-ink-muted">
                  {item.label}
                </Link>
              ) : (
                <span aria-current="page" className="min-w-0 truncate text-ink-muted">
                  {item.label}
                </span>
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
}
